import { Popover } from '@material-ui/core'
import styled from 'styled-components'

export const Popup = styled(Popover)`
  .MuiPopover-paper {
    width: 248px;
    box-shadow: none;
    border: 1px solid #dfe7f6;
    background-color: white;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }
`
export const PopupHeader = styled.div`
  padding: 16px;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px solid #dddddd;
`
export const PopupBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
export const PopupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`
export const PopupTitle = styled.label`
  font-weight: 700;
  font-size: 14px;
  color: #0a81ad;
`
export const PopupDescription = styled.label`
  font-weight: 700;
  font-size: 14px;
  color: #333333;
`
export const PopupRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`